import apiClient from "./apiClient";

export interface Coordinate {
    lat: number;
    lng: number;
}

export interface DeliveredCoordinate extends Coordinate {
    podCount: number;
}

export type UberSidedWith = 'GOOGLE' | 'RADAR' | 'BOTH' | 'NEITHER' | 'NO_UBER';
export type NearestToDelivery = 'GOOGLE' | 'RADAR' | 'UBER' | 'NO_POD';

export interface ProviderDisagreementRow {
    addressId: number;
    traceId: string | null;
    createdAt: string;
    fullAddress: string | null;
    stateCode: string | null;
    zip: string | null;
    google: Coordinate | null;
    radar: Coordinate | null;
    uber: Coordinate | null;
    delivered: DeliveredCoordinate | null;
    googleRadarDistanceM: number | null;
    uberSidedWith: UberSidedWith;
    nearestToDelivery: NearestToDelivery;
    uberWasRight: boolean | null;
}

export interface ProviderDisagreementsSummary {
    pctSidedGoogle: number;
    pctSidedRadar: number;
    pctSidedNeither: number;
    pctUberWasRight: number;
    totalRows: number;
}

export interface ProviderDisagreementsResponse {
    items: ProviderDisagreementRow[];
    page: number;
    pageSize: number;
    totalItems: number;
    summary: ProviderDisagreementsSummary;
}

export interface ProviderDisagreementsQueryParams {
    from?: string;
    to?: string;
    stateCode?: string;
    zip?: string;
    onlyDisagreements?: boolean;
    onlyWithPods?: boolean;
    page?: number;
    pageSize?: number;
}

const ProviderDisagreementsService = {
    getProviderDisagreements: async (params: ProviderDisagreementsQueryParams): Promise<ProviderDisagreementsResponse> => {
        const cleanParams: Record<string, any> = {};
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                cleanParams[key] = value;
            }
        });

        try {
            const response = await apiClient.get(`api/v1/reports/provider-disagreements`, {
                params: cleanParams
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching provider disagreements report:", error);
            throw error;
        }
    }
};

export default ProviderDisagreementsService;
